import React, { useEffect } from 'react';
import Input from 'components/ui/Input';
import Button from 'components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from 'store/auth';
import { updateLoading, updateLanguage } from 'store/app';

const Login = () => {
  const { t } = useTranslation();

  const { i18n } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { language } = useSelector((state) => state.app);

  const schema = yup
    .object({
      card: yup.string().required(t('form.required.label')),
    })
    .required();

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      card: '',
    },
  });

  const onSubmit = (values) => {
    //dispatch(updateLoading(true))
    dispatch(login(values))
      .then((res) => {
        if (res.payload.Result) {
          navigate('/validate', { state: { card: values.card } })
          reset()
        }
        dispatch(updateLoading(false))
      })
      .catch(() => {
        dispatch(updateLoading(false))
      })
  };

  const changeLanguage = (lang) => {
    dispatch(updateLanguage(lang));
    i18n.changeLanguage(lang);
  }

  useEffect(() => {
    changeLanguage(language);
    // eslint-disable-next-line
  }, [])

  return (
    <div className="h-full w-full flex flex-col justify-center items-center bg-[#fafafa] relative px-8">
      <div className="w-full h-fit flex flex-col gap-8 -mt-20">
        <div className="h-[30%] flex justify-center items-center mb-5">
          <img src="/library-logo.svg" alt='sheraton' />
        </div>
        <div className="w-3/4">
          <span className="font-bold text-4xl">
            {t('auth.login_title')}
          </span>
        </div>
        <span className="text-xs text-[#808080] font-semibold">
          {t('auth.login_text')}
        </span>
        <Input
          name="card"
          type="number"
          placeholder={t('auth.insert_employee_id')}
          label={t('auth.insert_employee_id')}
          register={register}
          error={errors.card}
          noMsgError
        />
        <Button
          onClick={handleSubmit(onSubmit)}
          text={t('general.next')}
        />
      </div>
      <div className="absolute bottom-10 w-full px-8 flex justify-between items-center">
        <span className="text-xs text-[#808080] font-semibold">
          {t('language.change')}
        </span>
        <span className="text-xs text-[#808080] font-semibold uppercase" onClick={() => changeLanguage(language === 'pt' ? 'en' : 'pt')}>
          {language === 'pt' ? t('language.en') : t('language.pt')}
        </span>
      </div>
    </div>

  )
}

export default Login;